module.exports = __webpack_public_path__ + "img/marron-7.b053129a.png";